const Yt = (props) => (
  <svg viewBox='0 0 32 32' fill='none' {...props}>
    <path fillRule='evenodd' clipRule='evenodd'
      d='M15.8612 31.8688C24.6124 31.8688 31.7067 24.7745 31.7067 16.0233C31.7067 7.27203 24.6124 0.177734 15.8612 0.177734C7.10992 0.177734 0.015625 7.27203 0.015625 16.0233C0.015625 24.7745 7.10992 31.8688 15.8612 31.8688ZM23.7738 11.7084C23.5752 10.9707 22.9935 10.389 22.2558 10.1904C20.908 9.82149 15.5168 9.82149 15.5168 9.82149C15.5168 9.82149 10.1257 9.82149 8.77788 10.1762C8.05433 10.3748 7.45846 10.9707 7.25984 11.7084C6.90516 13.0562 6.90516 15.8511 6.90516 15.8511C6.90516 15.8511 6.90516 18.6602 7.25984 19.9938C7.45846 20.7315 8.04014 21.3132 8.77788 21.5118C10.1399 21.8807 15.5168 21.8807 15.5168 21.8807C15.5168 21.8807 20.908 21.8807 22.2558 21.526C22.9935 21.3274 23.5752 20.7457 23.7738 20.0079C24.1285 18.6602 24.1285 15.8653 24.1285 15.8653C24.1285 15.8653 24.1427 13.0562 23.7738 11.7084ZM13.7997 18.4305L18.2829 15.8484L13.7997 13.2663V18.4305Z'
      fill='#FFE42B' />
  </svg>
)

export default Yt



// WEBPACK FOOTER //
// ./components/icons/yt.js